import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Información del padre", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-name"
}, "Nombre del padre", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-email-personal"
}, "Correo personal", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-email-work"
}, "Correo laboral", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-phone-personal"
}, "Teléfono personal", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-phone-work"
}, "Teléfono laboral", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-occupation"
}, "Ocupación", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-father-employer"
}, "Empleador", -1)
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mt-4 mb-3" }, "Información de la madre", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-name"
}, "Nombre de la madre", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-email-personal"
}, "Correo personal", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-email-work"
}, "Correo laboral", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-phone-personal"
}, "Teléfono personal", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-phone-work"
}, "Teléfono laboral", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-occupation"
}, "Ocupación", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-mother-employer"
}, "Empleador", -1)
const _hoisted_18 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "input-father-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('FatherName', val)),
                  type: "text",
                  placeholder: "Ingrese nombre del padre"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "input-father-email-personal",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherEmailPersonal,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('FatherEmailPersonal', val)),
                  type: "email",
                  placeholder: "Ingrese correo personal"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_b_form_input, {
                  id: "input-father-email-work",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherEmailWork,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('FatherEmailWork', val)),
                  type: "email",
                  placeholder: "Ingrese correo laboral"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "input-father-phone-personal",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherPhonePersonal,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('FatherPhonePersonal', val)),
                  type: "tel",
                  placeholder: "Ingrese teléfono personal"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_b_form_input, {
                  id: "input-father-phone-work",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherPhoneWork,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('FatherPhoneWork', val)),
                  type: "tel",
                  placeholder: "Ingrese teléfono laboral"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_b_form_input, {
                  id: "input-father-occupation",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherOccupation,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('FatherOccupation', val)),
                  type: "text",
                  placeholder: "Ingrese ocupación"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_b_form_input, {
                  id: "input-father-employer",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.FatherEmployer,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('FatherEmployer', val)),
                  type: "text",
                  placeholder: "Ingrese empleador"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.recordProxy.FatherLivesWithStudent,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('FatherLivesWithStudent', !!val))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vive con el estudiante ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.recordProxy.FatherIsLegalGuardian,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('FatherIsLegalGuardian', !!val))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Es tutor legal ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.recordProxy.FatherDeceased,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('FatherDeceased', !!val))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Fallecido ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_10,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherName,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = val => _ctx.updateField('MotherName', val)),
                  type: "text",
                  placeholder: "Ingrese nombre de la madre"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_12,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-email-personal",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherEmailPersonal,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = val => _ctx.updateField('MotherEmailPersonal', val)),
                  type: "email",
                  placeholder: "Ingrese correo personal"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-email-work",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherEmailWork,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = val => _ctx.updateField('MotherEmailWork', val)),
                  type: "email",
                  placeholder: "Ingrese correo laboral"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-phone-personal",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherPhonePersonal,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = val => _ctx.updateField('MotherPhonePersonal', val)),
                  type: "tel",
                  placeholder: "Ingrese teléfono personal"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_15,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-phone-work",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherPhoneWork,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = val => _ctx.updateField('MotherPhoneWork', val)),
                  type: "tel",
                  placeholder: "Ingrese teléfono laboral"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_16,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-occupation",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherOccupation,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = val => _ctx.updateField('MotherOccupation', val)),
                  type: "text",
                  placeholder: "Ingrese ocupación"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_17,
                _createVNode(_component_b_form_input, {
                  id: "input-mother-employer",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.MotherEmployer,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = val => _ctx.updateField('MotherEmployer', val)),
                  type: "text",
                  placeholder: "Ingrese empleador"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.recordProxy.MotherLivesWithStudent,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = val => _ctx.updateField('MotherLivesWithStudent', !!val))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Vive con el estudiante ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.recordProxy.MotherIsLegalGuardian,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = val => _ctx.updateField('MotherIsLegalGuardian', !!val))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Es tutor legal ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.recordProxy.MotherDeceased,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = val => _ctx.updateField('MotherDeceased', !!val))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Fallecida ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}